<template>
  <div class="blog-layout blog-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'BlogLayout',
  data() {
    return {
      observer: null // 用于存储MutationObserver实例
    }
  },
  mounted() {
    // 确保隐藏App.vue中的全局移动端菜单按钮
    this.hideGlobalMobileMenu()
    
    // 设置定时器，确保在DOM完全渲染后再次尝试隐藏
    setTimeout(() => {
      this.hideGlobalMobileMenu()
    }, 100)
    
    // 添加MutationObserver监听DOM变化
    this.setupMutationObserver()
  },
  beforeDestroy() {
    // 清理MutationObserver
    if (this.observer) {
      this.observer.disconnect()
    }
    
    // 恢复App.vue中的全局移动端菜单按钮显示
    this.restoreGlobalMobileMenu()
  },
  methods: {
    // 隐藏App.vue中的全局移动端菜单按钮
    hideGlobalMobileMenu() {
      // 使用更精确的选择器
      const globalMobileMenuBtns = document.querySelectorAll('#app > .mobile-menu-btn, body > #app > .mobile-menu-btn')
      globalMobileMenuBtns.forEach(btn => {
        btn.style.display = 'none'
        btn.setAttribute('style', 'display: none !important')
      })
    },
    
    // 设置MutationObserver监听DOM变化
    setupMutationObserver() {
      // 创建MutationObserver监听DOM变化
      this.observer = new MutationObserver(() => {
        this.hideGlobalMobileMenu()
      })
      
      // 开始观察
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    },
    
    // 恢复App.vue中的全局移动端菜单按钮显示
    restoreGlobalMobileMenu() {
      const globalMobileMenuBtn = document.querySelector('#app > .mobile-menu-btn')
      if (globalMobileMenuBtn) {
        // 只在移动端视图下恢复显示
        if (window.innerWidth <= 768) {
          globalMobileMenuBtn.style.display = 'flex'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
html, body {
  overflow: hidden !important;
  height: 100%;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none !important;
}

.blog-layout {
  height: 100vh;
  width: 100vw;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  position: relative;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
.blog-layout::-webkit-scrollbar {
  display: none !important;
}

/* 添加博客容器特定的全局样式，覆盖App.vue中的移动端样式 */
:deep(.mobile-menu-btn) {
  display: none !important; /* 强制隐藏App.vue中的移动端菜单按钮 */
}

/* 隐藏博客相关页面的滚动条 */
.blog-layout,
.blog-layout * {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.blog-layout *::-webkit-scrollbar {
  display: none !important;
}

/* 全局滚动条隐藏 */
html, body {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none !important;
}
</style> 